<template>
  <div id="app">
    <v-app id="inspire">
      <v-app id="inspire">
        <p>dasdasdasda</p>
        <router-view></router-view>
      </v-app>
    </v-app>
  </div>
</template>
<script>
export default {
  name: 'Courses',
}
</script>
